<template>
  <div>
    <h5 v-html="(active+1) +'.'+ data[active].examcont+'（'+ data[active].scores+'分）' "></h5>
    <div v-if="data[active].isvoice == 'Y'">
      <van-cell-group>
        <wxaudioplay v-model="data[active].examansws" @saveanswer="saveanswer" :infoid="data[active].examinfoid+''" :kid="paperId+''"  :key="data[active].examinfoid"></wxaudioplay>
      </van-cell-group>
    </div>
    <div v-else-if="data[active].isvideo == 'Y'">
       <van-cell-group>
      <video controls="controls" height="150" width="300" v-if="data[active].examansws.length>0">
          <source :src="data[active].examansws[0].url" :type="data[active].examansws[0].content">
        </video>
        <videopay  v-model="data[active].examansws" @saveanswer="saveanswer" :url="'/student/examonline/examanswervr?inofid='+data[active].examinfoid+'&kid='+paperId" :key="data[active].examinfoid"></videopay>
      </van-cell-group>
    </div>
    <div v-else-if="data[active].isvideo != 'Y' && data[active].isvoice != 'Y'" >
      <van-cell-group>
        <vupimg v-model="data[active].examansws" @saveanswer="saveanswer" :url="'/student/examonline/examanswerimg?inofid='+data[active].examinfoid+'&kid='+paperId" :key="data[active].examinfoid"></vupimg>
      </van-cell-group>
    </div>
    <div style="height: 100px;width: 100%" ></div>
  </div>
</template>
<script>
  import vupimg from '../../common/uploadimg.vue'
  import wxaudioplay from '../../common/wxaudioplay.vue'
  import videopay from '../../common/videopay.vue'

export default {
  components: {
    vupimg,
    wxaudioplay,
    videopay,
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    paperId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      maxlength: 50,
      answer: ''
    }
  },
  methods:
  {
    saveanswer()
    {
      this.$emit('saveda');
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/examonline/components/qAndA.vue